import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { countries } from '~/shared/config/constants'
import { AutocompleteInput, DatePickerInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type DrivingLicenseProps = {
  disabled?: boolean
  skeletonShow?: boolean
}

export function DrivingLicense({
  disabled,
  skeletonShow,
}: DrivingLicenseProps) {
  const { t } = useTranslation()

  return (
    <Container data-testid='driving-license-form-container'>
      <ContainerTitle>{t('driver license')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <AutocompleteInput
            label='form.country of issue'
            placeholder='form.select country of issue'
            name='drivingLicenseIssuingCountry'
            options={countries}
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.number'
            placeholder='form.enter number'
            name='drivingLicenseNumber'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.issue date'
            placeholder='form.enter issue date'
            name='drivingLicenseIssueDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.driving experience start date'
            placeholder='form.enter driving experience start date'
            name='drivingExperienceStartDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.expiration date'
            placeholder='form.enter expiration date'
            name='drivingLicenseExpirationDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
